import React from "react"
import {
  Window,
  View,
  Text,
  Toggle,
  Grid,
  Col,
  Tooltip,
} from "react-ame-components"

export class TooltipExample extends React.Component {
  render() {
    return (
      <Window>
        <View
          direction="column"
          align="center"
          justify="center"
          marginTop="big">
          <Grid>
            <Col columnSize={{ sm: 1, md: 3 }}></Col>
            <Col columnSize={{ sm: 10, md: 6 }}>
              <View
                backgroundColor="neutral-100"
                padding="big"
                borderRadius="small"
                shadow="level-2"
                direction="column"
                align="center">
                <Text
                  fontSize="large"
                  lineHeight="large"
                  fontWeight="bold">
                  Componente [color=primary]Tooltip[/color]
                </Text>
                <Text>Este componente serve para exibir um Tooltip</Text>
                <View margin="small">
                  <View marginTop="small">
                    <Text>
                      Lorem Ipsum is{` `}
                      <Tooltip
                        label="Olá eu o Tooltip"
                        position="left">
                        <Text>[b]jbkbjbjb[/b]</Text>
                      </Tooltip>
                      {` `}
                      dummy text of the printing and typesetting industry. Lorem
                      Ipsum has been the industry's standard dummy text ever
                      since the 1500s, when an unknown printer took a galley of
                      type and scrambled it to make a type specimen book. It has
                      survived not only five centuries, but also the leap into
                      electronic typesetting, remaining essentially unchanged.
                      It was popularised in the 1960s with the release of
                      Letraset sheets containing Lorem Ipsum passages, and more
                      recently with desktop publishing software like Aldus
                      PageMaker including versions of Lorem Ipsu
                    </Text>
                  </View>
                </View>
              </View>
            </Col>
            <Col columnSize={{ sm: 1, md: 3 }}></Col>
          </Grid>
        </View>
      </Window>
    )
  }
}
